export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-background-100 to-background-50 rounded-3xl p-8 md:p-12 border border-background-200">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                有任何影视推荐需求、内容建议或合作意向？欢迎联系极速影视团队，我们将竭诚为你提供帮助。
              </p>
              <div className="flex flex-col gap-3 text-sm text-foreground-600">
                <div className="flex items-center gap-3 justify-center md:justify-start">
                  <i className="ri-mail-line text-primary-500"></i>
                  <span>contact@jisumovie.com</span>
                </div>
                <div className="flex items-center gap-3 justify-center md:justify-start">
                  <i className="ri-customer-service-line text-primary-500"></i>
                  <span>在线客服：每日 9:00 - 24:00</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-send-plane-line"></i>
                发送消息
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}